import React from 'react';
import VideoEmbed from '../basic/videoEmbed';
import * as timelineStyle from "./timeline.module.scss";

const TimelineVideo = props => (
  <div className={timelineStyle.timelineBlock}>
    <div className="row row--center-horz">
      <div className="col-xs-12 col-lg-10 push-lg-2">
        <VideoEmbed {...props} isTimeline />
      </div>
    </div>
  </div>
);

export default TimelineVideo;
